import React from 'react'

import { OpeningTimesSection, PricingSection, Grid } from '@mytours/components'
import { SectionListGroupContainer as Container, ScreenSectionItem } from 'mytours-read-common'

import { formatCurrency, getDirMode } from '../../../platform'
import SectionHeader from './SectionHeader'

import '../styles/sectionGroup.less'
import '../styles/sectionListGroup.less'

interface Props {
	type: 'price' | 'opening_hours'
}

// Exception rows omit prices; a zero-cent price remains valid when it has a currency.
const priceFor = (item: ScreenSectionItem): string | undefined => {
	if (item.exception_row || !item.price_currency) {
		return undefined
	}
	return formatCurrency(item.price_currency, item.price_cents ?? 0)
}

// Keep the library rows inside the app's heading and responsive list-layout shell.
const SectionListGroup: React.FC<Container.Props & Container.Actions & Props> = ({ section, type }) => {
	const items = section.section_items ?? []
	const shared = {
		className: `section-group-list block-content ${getDirMode()}`,
		dir: getDirMode(),
		dataCy: 'story-screen-section',
	}

	return (
		<Grid className="section-group list-layout">
			<SectionHeader title={section.title} />
			{type === 'price' ? (
				<PricingSection
					{...shared}
					items={items.map(item => ({
						id: item.id,
						description: item.description ?? '',
						price: priceFor(item),
					}))}
				/>
			) : (
				<OpeningTimesSection
					{...shared}
					items={items.map(item => ({
						id: item.id,
						description: item.description ?? '',
						time: item.exception_row ? undefined : item.time,
					}))}
				/>
			)}
		</Grid>
	)
}

const SectionListGroupComponent = Container.default(SectionListGroup)

export default SectionListGroupComponent
